import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTIONS_UPLOAD_PRESCRIPTION } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { toast } from "../../components/app-toast";
import {
  getLocalizedMessage,
  getLocalizedErrorMessage,
} from "../../utils/messageHelper";
import i18n from "../../i18n";

export const uploadPrescription = createAsyncThunk(
  ACTIONS_UPLOAD_PRESCRIPTION.upload,
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.uploadPrescription}`,
        payload,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        // Use localized success message
        const message = getLocalizedMessage(response, i18n);
        toast.success(message);

        return response.data;
      } else {
        // Use localized error message
        const message = getLocalizedErrorMessage({ response }, i18n);
        toast.error(message);

        return rejectWithValue(response.data);
      }
    } catch (error) {
      // Use localized error message
      const message = getLocalizedErrorMessage(error, i18n);
      toast.error(message);

      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);
